<template>
  <nav>
    <ul class="nav-list">
      <li>
        <localized-link to="/entities">
          {{ $t("navigation.entities") }}
        </localized-link>
      </li>
      <li>
        <localized-link to="/audit">
          {{ $t("navigation.audit") }}
        </localized-link>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  name: "NavList",
};
</script>

<style lang="scss" scoped>
.el-dropdown-link {
  cursor: pointer;
}
nav {
  flex: 1 1 auto;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  ul {
    padding: 0 15px;
    margin: 0;
    list-style: none;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: -1px;
    li {
      padding: 0 5px;
    }
    :deep() {
      a {
        padding: 10px 5px;
        display: block;
      }
    }
  }
}
.el-dropdown-menu {
  &__item {
    padding: 0 0;
    :deep() .el-link {
      text-align: left;
      padding: 0 20px;
      width: 100%;
      text-decoration: none !important;
      display: block;
      &::after {
        display: none;
      }
    }
  }
}
</style>
